import { destinations } from "@/data/destinations";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export default function FeaturedDestinations() {
  // Separate destinations into national and international
  const nationalDestinations = destinations.filter(dest => dest.category === 'national');
  const internationalDestinations = destinations.filter(dest => dest.category === 'international');

  const DestinationCarousel = ({ items, title }: { items: typeof destinations, title: string }) => (
    <div className="mb-4 md:mb-8 last:mb-0">
      <h2 className="text-lg md:text-xl 2xl:text-2xl text-white mb-2 md:mb-4 text-center font-['MontserratAlt1'] font-light">
        {title}
      </h2>
      <div className="relative px-2 md:px-6 lg:px-8">
        <Carousel
          opts={{
            align: "start",
            loop: true,
            skipSnaps: false,
            dragFree: true,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {items.map((destination) => (
              <CarouselItem key={destination.id} className="pl-2 md:pl-4 basis-[75%] sm:basis-1/2 lg:basis-1/3 2xl:basis-1/4 group">
                <Card className="bg-white/95 border-none shadow-sm group-hover:shadow-xl transition-all duration-500 overflow-hidden transform group-hover:scale-105">
                  <CardContent className="p-0">
                    <div className="relative">
                      <img
                        src={destination.image}
                        alt={destination.name}
                        className="w-full aspect-[16/9] object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent transition-opacity duration-500 group-hover:opacity-90" />
                      <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 transform transition-all duration-500">
                        <h3 className="text-white text-base md:text-lg 2xl:text-xl mb-1 md:mb-2 text-center font-['Playfair_Display'] group-hover:scale-105">
                          {destination.name}
                        </h3>
                        <p className="text-white/90 text-xs md:text-sm 2xl:text-base text-center line-clamp-2 transition-all duration-500 group-hover:text-white">
                          {destination.description}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:block absolute top-1/2 -translate-y-1/2 w-full left-0">
            <div className="container max-w-[2000px] mx-auto px-4 relative">
              <CarouselPrevious className="absolute bg-white/90 hover:bg-white left-0 h-9 w-9 lg:h-10 lg:w-10 transition-all duration-300" />
              <CarouselNext className="absolute bg-white/90 hover:bg-white right-0 h-9 w-9 lg:h-10 lg:w-10 transition-all duration-300" />
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );

  return (
    <div className="space-y-4 md:space-y-8">
      <DestinationCarousel items={nationalDestinations} title="Destinos Nacionais" />
      <DestinationCarousel items={internationalDestinations} title="Destinos Internacionais" />
    </div>
  );
}